import { FC } from "react";
import { PageProps } from "./Page1";
import Letterhead from "./Letterhead";

const Page6: FC<PageProps> = ({ data }) => {
  return (
    <Letterhead data={data} pageNumber={6}>
      <p className="text-lg font-bold">ماده ۱۳)</p>
      <p className="mb-2 text-lg font-bold">فسخ قرارداد</p>
      <p className="text">
        ۱-۱۳ فسخ قرارداد از سوی هر یک از طرفین تنها در صورتی امکان‌پذیر است که سه ماه قبل و به صورت
        کتبی به طرف مقابل اعلام شود. بدیهی است که طرفین طی ۱۵ روز کاری ملزم به تسویه حساب مالی با
        یکدیگر هستند به نحوی که هیچ گونه بدهی مالی میان طرفین نباشد.
      </p>
      <p className="text">
        ۲-۱۳ پذیرنده حق استفاده از نام تجاری آپولون را پس از فسخ قرارداد و یا پایان مدت آن نخواهد
        داشت.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۱۴)</p>
      <p className="mb-2 text-lg font-bold">نشانی قانونی</p>
      <p className="text">
        اطلاعات نشانی و تماس طرفین جهت انجام مراودات، مکاتبات و اطلاع‌رسانی می باشد. هرگونه تغییر در
        اطلاعات تماس و نشانی قانونی می-بایست در اسرع وقت و به‌صورت کتبی به طرف دیگر اطلاع‌رسانی
        گردد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۱۵)</p>
      <p className="text">
        این قرارداد شامل ۱۵ ماده و ۷ تبصره در دو نسخه متحدالشکل تنظیم و در تاریخ{" "}
        <span className="font-bold">1405/07/21</span> در محل آپولون منعقد گردیده است و هر دو نسخه
        دارای اعتبار واحد می‌باشد.
      </p>
    </Letterhead>
  );
};

export default Page6;
